export default __webpack_public_path__ + "static/media/apply-leave.bb4ff7b3.svg";